import { FormControl, FormControlEmail, FormControlPhone } from './form-control'

function createInputControl(input) {
  if (input.type === 'email') {
    return new FormControlEmail(input)
  } else if (input.type === 'tel') {
    return new FormControlPhone(input)
  } else {
    return new FormControl(input)
  }
}

/**
 *
 * @param {HTMLElement} control
 */
export function createFormControl(control) {
  if (control.type === 'hidden') return
  if (control.tagName === 'INPUT') {
    return createInputControl(control)
  }
  if (control.tagName === 'SELECT') {
    return createInputControl(control)
  }
}
